// extracted by mini-css-extract-plugin
module.exports = {"customClass":"UserSignUp-module__customClass"};